
import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent, CardHeader } from "@/components/ui/card";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, icon: Icon }) => {
  return (
    <Card className="service-card h-full transition-all border border-gray-100 hover:border-noordpink-light relative overflow-hidden">
      <CardHeader className="pb-2">
        <div className="w-14 h-14 bg-noordpink-light rounded-full flex items-center justify-center mb-4">
          <Icon className="h-7 w-7 text-noordpink" />
        </div>
        <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600">{description}</p>
        
        {/* Small puzzle icon in corner to reflect the logo theme */}
        <div className="absolute bottom-0 right-0 opacity-5">
          <img 
            src="/lovable-uploads/90135dc0-ec18-415d-9b80-9a2fbf8a45e0.png"
            alt=""
            className="w-16 h-16"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
